import React, { useEffect, useState } from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import * as API from "services/api"
import { shortMonthDate } from "utils/dateHelpers"
import { AttachmentTypeIcon } from "shared/icons"
import TruncateText from "shared/TruncateText"
import { formSubmissionSlug as getFormSubmissionSlug } from "reduxSlices/formSubmissionSlice"
import AttachmentMenu from "./AttachmentMenu"

const VIA_FORM_TYPE = "submitted_files"
const PDF_FILE_TYPE = "pdf"
const CONTACT_SUPPORT_COPY = "Email support@performancehealth.app for assistance."

const AttachmentCard = ({ attachment }) => {
  const {
    id: attachmentId, isRepresentable, fileType, filename, createdAt, type, path: src,
  } = attachment
  const formSubmissionSlug = useSelector(getFormSubmissionSlug)
  const [imgSrc, setImgSrc] = useState(null)
  const [imgError, setImgError] = useState(false)
  const [fallback, setFallback] = useState("File not found.")

  useEffect(() => {
    const checkFilePermission = async () => {
      const response = await API.headAttachmentUrl({ formSubmissionSlug, attachmentId })

      if (response.ok) {
        setImgSrc(src)
      } else {
        setImgError(true)
        if (response.status === 403) {
          setFallback("File cannot be viewed.")
        }
      }
    }

    checkFilePermission()
  }, [attachment])

  return (
    <div className="bg-primary-light border border-lightgray-2 h-60 rounded-2xl light-shadow-lg relative">
      <AttachmentMenu attachment={attachment} isDownloadable={!!imgSrc} />
      <div className="flex justify-center h-2/3">
        {
          imgSrc
          && (
            isRepresentable && fileType !== PDF_FILE_TYPE
              ? <img src={imgSrc} alt={filename} />
              : <AttachmentTypeIcon className="h-16 w-16 self-center" fileType={fileType} />
          )
        }
        {
          imgError
          && (
            <div className="self-center mx-4 p-4">
              <div className="font-bold flex justify-center ">{fallback}</div>
              <div className="text-sm ">{CONTACT_SUPPORT_COPY}</div>
            </div>
          )
        }
      </div>
      <div className="bg-white p-4 h-1/3 rounded-b-2xl border-t border-lightgray-2">
        <TruncateText truncateOn={fileType} className="font-semibold">
          <span>{filename}</span>
        </TruncateText>
        <div className="text-dark text-sm font-medium">
          {shortMonthDate(createdAt)}
          {type === VIA_FORM_TYPE ? " via form" : " via Activity Hub"}
        </div>
      </div>
    </div>
  )
}

AttachmentCard.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  attachment: types.object.isRequired,
}

export default AttachmentCard
